import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import buildHubUrl from "src/utils/hubs/buildHubUrl";
import CreateConnection from "src/utils/hubs/HubMatrix";
import { connectToHubUser } from "src/redux/slices/hub";
import { getAlertasResumen, setAlertasResumen } from "src/redux/slices/gestion";

// 2026-10 · Contador de alertas de stock (stock bajo + negativo) para el menú
// «Inventario y costes». Se carga al montar, se actualiza en tiempo real con
// `stock-alerts/{restaurante}` (evento V2 `stock.alerts`, que el API emite
// tras cada cambio de stock solo si el resumen cambió) y, por si se pierde un
// aviso, se refresca al volver a la pestaña y cada 10 minutos.
// `enabled` = tiene el add-on y permiso de inventario (si no, ni se pide).

export const POLL_MS = 10 * 60 * 1000;

/** Normaliza el resumen (camelCase o PascalCase según el canal). */
export function normalizarResumen(p) {
  if (!p) return null;
  const n = (a, b) => Number(p[a] ?? p[b] ?? 0) || 0;
  return {
    total: n("total", "Total"),
    stockBajo: n("stockBajo", "StockBajo"),
    stockNegativo: n("stockNegativo", "StockNegativo"),
    sinCoste: n("sinCoste", "SinCoste"),
    incidenciasAbiertas: n("incidenciasAbiertas", "IncidenciasAbiertas"),
  };
}

export default function useStockAlerts(enabled) {
  const dispatch = useDispatch();
  const restauranteId = useSelector((s) => s.authJwt?.user?.id);
  const total = useSelector((s) => s.gestion?.alertasResumen?.total || 0);

  useEffect(() => {
    if (!enabled || !restauranteId) return undefined;
    dispatch(getAlertasResumen());

    const cleanup = CreateConnection(
      buildHubUrl("/hub/userhub", { restauranteId }),
      [{ id: `stock-alerts/${restauranteId}`, operator: (payload) => dispatch(setAlertasResumen(normalizarResumen(payload))) }],
      dispatch,
      connectToHubUser,
      "user",
    );
    const onVisible = () => {
      if (document.visibilityState === "visible") dispatch(getAlertasResumen());
    };
    document.addEventListener("visibilitychange", onVisible);
    const timer = setInterval(() => dispatch(getAlertasResumen()), POLL_MS);

    return () => {
      document.removeEventListener("visibilitychange", onVisible);
      clearInterval(timer);
      if (typeof cleanup === "function") cleanup();
    };
  }, [enabled, restauranteId, dispatch]);

  return enabled ? total : 0;
}
